import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { EmploymentRecordEntity } from './employment-record.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum EmploymentRecordActionTypes {
  LoadEmploymentRecords = '[EmploymentRecord] Load EmploymentRecords',
  AddEmploymentRecord = '[EmploymentRecord] Add EmploymentRecord',
  UpsertEmploymentRecord = '[EmploymentRecord] Upsert EmploymentRecord',
  AddEmploymentRecords = '[EmploymentRecord] Add EmploymentRecords',
  UpsertEmploymentRecords = '[EmploymentRecord] Upsert EmploymentRecords',
  UpdateEmploymentRecord = '[EmploymentRecord] Update EmploymentRecord',
  UpdateEmploymentRecords = '[EmploymentRecord] Update EmploymentRecords',
  DeleteEmploymentRecord = '[EmploymentRecord] Delete EmploymentRecord',
  DeleteEmploymentRecords = '[EmploymentRecord] Delete EmploymentRecords',
  ClearEmploymentRecords = '[EmploymentRecord] Clear EmploymentRecords',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.LoadEmploymentRecords;

  constructor(public payload: { employmentRecords: EmploymentRecordEntity[] }) {}
}

export class AddEmploymentRecord implements Action {
  public readonly type = EmploymentRecordActionTypes.AddEmploymentRecord;

  constructor(public payload: { employmentRecord: EmploymentRecordEntity }) {}
}

export class UpsertEmploymentRecord implements Action {
  public readonly type = EmploymentRecordActionTypes.UpsertEmploymentRecord;

  constructor(public payload: { employmentRecord: EmploymentRecordEntity }) {}
}

export class AddEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.AddEmploymentRecords;

  constructor(public payload: { employmentRecords: EmploymentRecordEntity[] }) {}
}

export class UpsertEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.UpsertEmploymentRecords;

  constructor(public payload: { employmentRecords: EmploymentRecordEntity[] }) {}
}

export class UpdateEmploymentRecord implements Action {
  public readonly type = EmploymentRecordActionTypes.UpdateEmploymentRecord;

  constructor(public payload: { employmentRecord: Update<EmploymentRecordEntity> }) {}
}

export class UpdateEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.UpdateEmploymentRecords;

  constructor(public payload: { employmentRecords: Update<EmploymentRecordEntity>[] }) {}
}

export class DeleteEmploymentRecord implements Action {
  public readonly type = EmploymentRecordActionTypes.DeleteEmploymentRecord;

  constructor(public payload: { id: string }) {}
}

export class DeleteEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.DeleteEmploymentRecords;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearEmploymentRecords implements Action {
  public readonly type = EmploymentRecordActionTypes.ClearEmploymentRecords;
}

export type EmploymentRecordActions =
  | LoadEmploymentRecords
  | AddEmploymentRecord
  | UpsertEmploymentRecord
  | AddEmploymentRecords
  | UpsertEmploymentRecords
  | UpdateEmploymentRecord
  | UpdateEmploymentRecords
  | DeleteEmploymentRecord
  | DeleteEmploymentRecords
  | ClearEmploymentRecords;
